<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">サービスパーツ商品EIAJ検収伝票発行設定</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="confirm" class="ml-2 mr-2">確定</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout row wrap>
              <v-radio-group v-model="radioGroup">
                <v-radio label="集約印刷" value="total"></v-radio>
                <v-radio label="集約印刷しない（品番毎個別印字)" value="sub"></v-radio>
                <v-radio label="一部無償EIAJ伝票発行する" value="free"></v-radio>
              </v-radio-group>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    radioGroup: ''
  }),
  methods: {
    popup() {
      this.show = true
    },
    confirm() {
      this.$emit('confirmData')
      this.show = false
    }
  }
}
</script>
